<a href="#" title="{{title | sqMessage}}" (click)="click()">
    <sq-collapse-button [collapsed]="collapsed" [icon]="icon" [text]="text"></sq-collapse-button>
</a>